import { useMemo } from 'react';
import { useApi } from '../infrastructure/useApi';
import { DEFAULT_API_OPTIONS } from '../infrastructure/defaults';
import { API_URLS } from '../apiUrls';
import { API_METHODS } from '../constants/apiMethods';

/**
 * Hook for accessing Dashboard API methods.
 *
 * Usage:
 * const { get, cancel } = useDashboardApi();
 * await get();
 *
 * Cancellation scope:
 * - cancel() applies to requests started by this hook instance.
 * - For independent cancellation scopes, create separate hook instances.
 */
export const useDashboardApi = (baseOptions = DEFAULT_API_OPTIONS) => {
	const { call, cancel } = useApi(baseOptions);

	return useMemo(
		() => ({
			get: () =>
				call({
					url: API_URLS.order.getDashboard(),
					method: API_METHODS.GET,
				}),

			cancel,
		}),
		[call, cancel]
	);
};
